export default {
  answerButton: {
    answer: "ANSWER",
    continue: "CONTINUE",
    end: "END"
  },
  feedback: {
    correct: "Correct!",
    incorrect: "Nope..."
  }
};
